// eslint-disable-next-line no-console
const log = (...ctx: any) => console.info("[@bounce/analytics]", ...ctx)

export { log }
